export default "__VITE_ASSET__X3QsGxdI__"